import React, { useContext, useState } from "react";
import Heading_banner_section from "../../common_components/heading_banner/Heading_banner_section";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Purple_Btn from "../../common_components/common_btn/purple_btn/Purple_Btn";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { Context } from "../../../utils/context";
import { useForm } from "react-hook-form";
import { ChangePassword } from "../../../utils/apis/myAccount/myAccount";
import SuccessfullyModal from "../../../components/Common-Component/Commonmodal/SuccessfullyModal/SuccessfullyModal";
import PasswordChecklist from "react-password-checklist";
import LogoutModal from "../../../components/Common-Component/Commonmodal/LogoutModal/LogoutModal";
function Update_password() {
  // const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "YOUR ACCOUNT", link: "/luxury/account" },
    { label: "Update Password" },
  ];

  // const togglePasswordVisibility = () => {
  //   setShowPassword(!showPassword);
  // };
  const { userdata,setSignin } = useContext(Context);
const [logoutshow, setLogoutshow] = useState(false);
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  const [passwordModal, setPasswordModal] = useState(false);
  const [showPasswordCurrent, setShowPasswordCurrent] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);
  const [iconCurrent, setIconCurrent] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    } else if (field === "current_password") {
      setShowPasswordCurrent(!showPasswordCurrent);
      setIconCurrent(showPasswordCurrent ? faEyeSlash : faEye);
    }
  };
  const [password, setPassword] = useState("");
  const [passwordCurrent, setPasswordCurrent] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");

  const onSubmit = async (data) => {
    if (password !== passwordCurrent) {
      if (password === passwordAgain) {
        const res = await ChangePassword(data);
        if (res?.success) {
          setPasswordModal(true);
          navigate("/luxury/account");
          reset();

          // hideModalWithDelay();
        } else {
          if (res?.message?.current_password) {
            setError("current_password", {
              message: res?.message?.current_password,
            });
          }
          if (res?.message?.errors?.current_password) {
            setError("current_password", {
              message: res?.message?.errors?.current_password?.msg,
            });
          }
        }
      } else {
        setError("current_password", { message: "Password must match" });
      }
    } else {
      setError("current_password", {
        message: "Current Password and New Password Not Same",
      });
    }
  };
  
  return (
    <>
      <section className="All_Orders Communication_preferences Manage_address Manage_address_form">
        <Heading_banner_section
          headingText={`${userdata?.first_name} ${userdata?.last_name}`}
          breadcrumbItems={breadcrumbItems}
        />

        <div className="custom_container">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="all_order_section_holder">
                <div className="text_holder">
                  <h3 className="sign_out_text"   onClick={() => setLogoutshow(true)}>
                    <FontAwesomeIcon
                      className="me-3"
                      icon={faArrowRightFromBracket}
                    
                    />
                    SIGN OUT
                  </h3>
                </div>

                <div className="heading_tab_content_holder">
                  <div className="heading_holder">
                    <h1>UPDATE PASSWORD</h1>
                    <p>Keep Your Password Updated For Enhanced Security</p>
                  </div>
                </div>

                <div className="row justify-content-center">
                  <div className="col-md-10">
                    <div className="content_box_holder">
                      <Form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                          <div className="col-md-12">
                            <Form.Group className="mb-3">
                              <Form.Label>Enter Current Password*</Form.Label>

                              <div className="password-container">
                                <Form.Control
                                  type={
                                    showPasswordCurrent ? "text" : "password"
                                  }
                                  placeholder="Enter Current Password*"
                                  {...register("current_password", {
                                    required: "current_password is required",
                                  })}
                                  onChange={(e) =>
                                    setPasswordCurrent(e.target.value)
                                  }
                                  // {...register("current_password")}
                                />

                                <span
                                  className="password-icon"
                                  onClick={() =>
                                    togglePasswordVisibility("current_password")
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={
                                      showPasswordCurrent ? faEye : faEyeSlash
                                    }
                                    className="eye-icon"
                                  />
                                </span>
                              </div>
                              {errors?.current_password && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors?.current_password?.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-md-12">
                            <Form.Group className="mb-3">
                              <Form.Label>Enter New Password*</Form.Label>

                              <div className="password-container">
                                <Form.Control
                                  type={showPassword ? "text" : "password"}
                                  placeholder="Enter Password*"
                                  {...register("new_password", {
                                    required: "New Password is required",
                                    minLength: {
                                      value: 8,
                                      message:
                                        "Password must be at least 8 characters long",
                                    },
                                    pattern: {
                                      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                                      message:
                                        "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                                    },
                                  })}
                                  onChange={(e) => setPassword(e.target.value)}
                                />

                                <span
                                  className="password-icon"
                                  onClick={() =>
                                    togglePasswordVisibility("password")
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={showPassword ? faEye : faEyeSlash}
                                    className="eye-icon"
                                  />
                                </span>
                              </div>
                              {errors?.new_password && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors?.new_password?.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-md-12">
                            <Form.Group className="mb-3">
                              <Form.Label>Confirm New Password*</Form.Label>

                              <div className="password-container">
                                <Form.Control
                                  type={showPasswordOne ? "text" : "password"}
                                  placeholder="Re-Enter Password*"
                                  {...register("re_password", {
                                    required: "Re-Password is required",
                                  })}
                                  onChange={(e) =>
                                    setPasswordAgain(e.target.value)
                                  }
                                />

                                <span
                                  className="password-icon"
                                  onClick={() =>
                                    togglePasswordVisibility("reenterPassword")
                                  }
                                >
                                  <FontAwesomeIcon
                                    icon={showPasswordOne ? faEye : faEyeSlash}
                                    className="eye-icon"
                                  />
                                </span>
                              </div>
                              {errors?.re_password && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors?.re_password?.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>
                        </div>
                        {password && (
                          <PasswordChecklist
                            rules={[
                              "minLength",
                              "specialChar",
                              "number",
                              "capital",
                              "match",
                            ]}
                            minLength={8}
                            value={password}
                            valueAgain={passwordAgain}
                            onChange={(isValid) => {}}
                            style={{
                              fontSize: "10px",
                              padding: "4px",
                              margin: "0",
                            }}
                          />
                        )}

                        <div className="btn_holder">
                          <div>
                            <Purple_Btn
                              btnText="Update"
                              type="submit"
                              // onClick={() => navigate("/luxury/account")}
                            />
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SuccessfullyModal
          show={passwordModal}
          onHide={() => setPasswordModal(false)}
          text={"Password Updated Successfully"}
        />
        <LogoutModal
          show={logoutshow}
          onHide={() => setLogoutshow(false)}
          text="Are you sure you want to log out?"
          setSignin={setSignin}
        />
      </section>
    </>
  );
}

export default Update_password;
